import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { fetchQueuesCached } from "../../utils/fetchQueuesCached";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(0.5),
  },
}));

const QueueSelectSingle = ({
  selectedQueueId,
  onChange,
  error = false,
  helperText = "",
}) => {
  const classes = useStyles();
  const [queues, setQueues] = useState([]);
  const [loading, setLoading] = useState(true);
  const errorShownRef = useRef(false);

  useEffect(() => {
    let active = true;
    errorShownRef.current = false;

    const loadQueues = async () => {
      setLoading(true);
      try {
        const data = await fetchQueuesCached();
        if (active) {
          setQueues(data);
        }
      } catch (err) {
        if (active && !errorShownRef.current) {
          errorShownRef.current = true;
          toastError(err);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadQueues();

    return () => {
      active = false;
    };
  }, []);

  const label = i18n.t("queueSelect.inputLabel");

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      margin="dense"
      fullWidth
      error={error}
    >
      <InputLabel id="queue-select-single-label">{label}</InputLabel>
      <Select
        labelId="queue-select-single-label"
        id="queue-select-single"
        label={label}
        value={selectedQueueId ?? ""}
        onChange={(event) => onChange(event.target.value)}
        disabled={loading}
      >
        <MenuItem value="">
          <em>{i18n.t("queueSelect.singlePlaceholder", { defaultValue: "Selecciona una cola" })}</em>
        </MenuItem>
        {queues.map((queue) => (
          <MenuItem key={queue.id} value={queue.id}>
            {queue.name}
          </MenuItem>
        ))}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};

export default QueueSelectSingle;
